import { Component, Input, OnInit, Output, EventEmitter, ViewChildren, QueryList } from '@angular/core';
import { useAnimation } from '@angular/animations';
import { IgxExpansionPanelComponent, slideInLeft, slideOutRight } from 'igniteui-angular';
import { SlideInOutAnimation } from '../../../../animations';
import { IgxToggleDirective } from 'igniteui-angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgramPageService } from '../program-page/program-page.service';
import { CustomAlertComponent } from 'src/app/shared/modals/custom-alert/custom-alert.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-programs-sidenav-igx',
	templateUrl: './programs-sidenav-igx.component.html',
	styleUrls: ['./programs-sidenav-igx.component.scss'],
	animations: [SlideInOutAnimation]
})
export class ProgramsSidenavIgxComponent implements OnInit {
	@ViewChildren(IgxExpansionPanelComponent) panels!: QueryList<IgxExpansionPanelComponent>;
	active_quiz: boolean = false;
	showGif = true;
	active_Video: boolean = false
	// public animationSettingsCustom = {
	// 	closeAnimation: useAnimation(slideOutRight, {
	// 		params: {
	// 			duration: '100ms',
	// 			toPosition: 'translateX(25px)',
	// 			startOpacity: 0.1
	// 		}
	// 	}),
	// 	openAnimation: useAnimation(slideInLeft, {
	// 		params: {
	// 			duration: '500s',
	// 			fromPosition: 'translateX(-15px)',
	// 			startOpacity: 1
	// 		}
	// 	})
	// };

	isExpanded = false;
	@Input() section: any;
	@Input() currentDateStatus: any;
	@Input() selectedSection: any;
	@Input() upcomingDay: any;
	@Input() prevDay: any;
	@Input() todaysDfs: any;
	@Output() selectedSectionEvent = new EventEmitter<any>();
	@Output() videoLocationEvent = new EventEmitter<any>();
	@Input() userProgress: any;
	@Input() index: any
	@Input() selectedTopicId: any;
	@Input() progressId: any;
	showQuizIconVar: boolean = false;
	animationState = 'out';
	items: any[] = [{}, {}, {}];
	expandedIndex: number = -1;
	alertShown: boolean = false;

	constructor(
		private dialogRef: MatDialog,
		private snackbar: MatSnackBar,
		private programService: ProgramPageService
	) {
		// console.log(this.section);
	}

	ngOnInit(): void { }

	clickedSection(section: any) {
		this.selectedSectionEvent.emit(section);
		section.toggle = !section.toggle;
	}

	clickedVideoTopic(section: any, topic: any) {
		this.selectedSectionEvent.emit(section);
		this.videoLocationEvent.emit({
			section,
			topic
		});
	}

	clickedVideoTopicInChild(obj: any) {
		this.selectedSectionEvent.emit(obj.section);
		this.videoLocationEvent.emit({
			section: obj.section,
			topic: obj.topic
		});
	}

	isSectionCompleted(sectionNo: number, sections: any): boolean {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					if (section.menu.length >= 1) {
						const isSectionComplete = this.isSectionCompleted(sectionNo, section.menu);

						if (isSectionComplete) {
							return true;
						} else {
							continue;
						}
					}
				} else if ((section.type === 'video' || section.type === 'Video' || section.type === 'quiz' || section.type === 'Quiz') && section.sno === sectionNo) {
					if (section.progress === 100) {
						return true;
					}
					return false;
				}
			}
		}

		return false;
	}

	isTopicCompleted(sectionNo: any, topicId: string, sections: any) {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					if (section.menu.length >= 1) {
						const isSectionComplete = this.isTopicCompleted(sectionNo, topicId, section.menu);

						if (isSectionComplete) {
							return true;
						} else {
							continue;
						}
					}
				} else if (section.type === 'video' || section.type === 'Video' && section.sno === sectionNo) {
					for (let topic of section.metadata?.topics) {
						if (topic.id === topicId && topic.progress === 100) {
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	getTaskStatus(section: any) {
		if (section.progress === 0) {
			return 'task_not_attempted_line';
		} else if (section.progress > 0 && section.progress < 100) {
			return 'task_partially_completed_line';
		} else if (section.progress === 100) {
			return 'task_completed_line';
		}
	}

	getTopicStatus(sectionNo: any, topicId: any, sections: any): any {
		if (topicId == this.selectedTopicId) {
			return 'selected_video'
		}

		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.sno === sectionNo) {

					for (let topic of section.metadata?.topics) {
						if (topic.id === topicId) {
							if (topic.progress === 0) {
								return 'task_not_attempted_line';
							} else if (topic.progress > 0 && topic.progress < 100) {
								return 'task_partially_completed_line';
							} else if (topic.progress === 100) {
								return 'task_completed_line';
							}
						}

					}
				}

				if (section.type === 'menu') {
					return this.getTopicStatus(sectionNo, topicId, section.menu);
				}
			}
		}

		return 'task_not_attempted_line';
	}

	showQuizIcon(section: any) {
		// console.log('sectionnnnnn', section)
		// for (let section of sections.menu) {
		if (section.type === 'quiz' || section.type === 'Quiz') {
			// console.log('its a quizzzzzzzz')
			return true;
		}
		// }
	}

	toggleShowDiv(divName: string) {
		if (divName === 'divA') {
			// console.log(this.animationState);
			this.animationState = this.animationState === 'out' ? 'in' : 'out';
			// console.log(this.animationState);
		}
	}

	activeQuiz(sectionNo: any) {
		if (sectionNo == this.selectedSection?.sno) {
			return 'selected_quiz';
		}
	}

	activeVideo(topicId: any): any {
		if (topicId == this.selectedTopicId) {
			return 'selected_video';
		}
	}

	async downloadDocument(sectionDfs: any, downloadLink: string) {
		if (this.userProgress.progress < 100) {
			var prevSectionDfs = Number(sectionDfs) - 1;
			var isPrevDfsCompleted = false;

			if (prevSectionDfs >= 1) {
				isPrevDfsCompleted = this.checkIfDfsIsCompleted(prevSectionDfs, this.userProgress.sections);
			} else {
				isPrevDfsCompleted = true;
			}

			if (!isPrevDfsCompleted) {
				if (this.selectedSection.type === "quiz" && !this.alertShown) {
					this.openCustomAlert("quiz");
				} else if (this.selectedSection.type === "download" && !this.alertShown) {
					this.openCustomAlert("download");
				} else if (!this.alertShown) {
					console.log("6");
					this.snackbar.open("Oops! Still need to finish previous tasks.", "OK");
				}
				this.alertShown = true;
				setTimeout(() => {
					this.alertShown = false;
				}, 3000);
				return;
			} else {
				window.open(downloadLink, "_blank");
				this.updateProgress(sectionDfs, this.userProgress.sections);
				await this.programService.saveDownloadProgress(this.progressId, this.userProgress);
			}
		}
	}

	updateProgress(sectionDfs: any, sections: any) {
		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					this.updateProgress(sectionDfs, section.menu);
				} else if ((section.type === 'download' || section.type === 'Download') && section.dfs === sectionDfs) {
					section.progress = 100;
				}
			}
		}
	}

	checkIfDfsIsCompleted(i: number, sections: any) {
		let [dfsProgress, totalDfsProgress] = this.getProgressForDfs(i, sections);
		if (dfsProgress === totalDfsProgress) {
			return true;
		}

		return false;
	}

	getProgressForDfs(dateDfs: number, sections: any) {
		let progress = 0;
		let totalProgress = 0;

		if (sections && sections.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					let [menuprogress, menuTotalProgress] = this.getProgressForDfs(dateDfs, section.menu);
					progress += menuprogress;
					totalProgress += menuTotalProgress;
				} else if (section.dfs === dateDfs && (section.type === 'video' || section.type === 'Video' || section.type === 'quiz'|| section.type === 'Quiz' || section.type === 'download' || section.type === 'Download')) {
					progress += section.progress;
					totalProgress += 100;
				}
			}
		}

		return [progress, totalProgress];
	}

	openCustomAlert(type:string) {
		this.dialogRef.open(CustomAlertComponent, {
			data: {
				type
			},
			panelClass: `${type}-alert-class`,
			backdropClass: 'custom-alert-backdrop-class'
		})
	}
}
